import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import FinanceSettingsLayout from "./FinanceSettingsLayout";
import { MENU, FINANCE_SETTINGS_BASE, financeSettingsDefaultRoute } from "./config";

// Rutas /finance-settings desde la config de navegación (mismo patrón que Gastos
// y Presupuestos): el sub-menú y las rutas nunca divergen.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={financeSettingsDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const financeSettingsRoute: RouteObject = {
  path: FINANCE_SETTINGS_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <FinanceSettingsLayout />,
      children,
    },
  ],
};
